import React, { FC, useState } from "react";
import { useDispatch } from "react-redux";
import { dsApi } from "api/rtkQueryApi/DsApi";
import {
  clearSessionStorage,
  setAccessToken,
} from "localStorage/LocalStoreManagerService";
import {
  getDefaultAuthContextValue,
  IAuthContextValue,
} from "authentication/AuthContext";

const LogoutPage: FC = () => {
  const dispatch = useDispatch();
  const [, setAuthContextValue] = useState<IAuthContextValue>(
    getDefaultAuthContextValue(),
  );

  setAccessToken("");
  setAuthContextValue((prevState) => ({
    ...prevState,
    isAuthenticated: false,
  }));
  dispatch(dsApi.util.resetApiState());
  clearSessionStorage();

  window.location.href = "/";

  return <React.Fragment></React.Fragment>;
};

export default LogoutPage;
